import {
  LOCALSTORAGE_KEY,
  metaTempleImg,
  orderType,
} from "../../utils/Constants";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  checkIfChadhavaDisabled,
  dayNameToNumber,
  getAvailableMonth,
  getDateFormatedForMUISelection,
  getExcludedChadhavaSubsList,
  getFilteredChadhavaSubsList,
  getImageListFromTemple,
  getOneImageForTemple,
  getTotalChadhavaSubscriptionPrices,
  getUpcomingDatesForDays,
  isSubscriptionAvailable,
  truncateToTwoDecimals,
  uid,
} from "../../utils/HelperFunctions";
import ParentView from "../../Views/PrarentView/ParentView";
import ChadhavaDetailsView from "../../Views/Chadhava/ChadhavaDetailsView";
import dayjs from "dayjs";
import { updateTempCartPayloadAction } from "../../store/actions/cartAction";
import { getChadhavaForTempleWithTempleDetails } from "../../store/actions/ChadhawaAction";
import HelmetComponent from "../../components/Shared/HelmetComponent";
import moment from "moment";
import { getDeviceTypeFromUserAgent } from "../../utils/analyics/analyticsHelper";
import { pageReady } from "../../store/slices/pageViewSlice";

function ChadhavaDetailsScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch: any = useDispatch();
  const [selectedTempleDetails, setSelectedTempleDetails] = useState<any>(null);
  const [localRestrictionChadavaDate, setLocalRestrictionChadavaDate] =
    useState<string[]>([]);
  const [templeId, setTempleId] = useState<string>("");
  const [chadhavaList, setChadhavaList] = useState<any>([]);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [totalPriceDisplay, setTotalPriceDisplay] = useState<number>(0);
  const [selectedChadhva, setSelectedChadhva] = useState<any>([]);
  const [isDateTimePicker, setIsDateTimePicker] = useState(false);
  const [filteredChadhavaList, setFilteredChadhavaList] = useState<any>(null);
  const [firstSelectedItemDate, setFirstSelectedItemDate] = useState("");
  const [pujaDateAndTime, setPujaDateAndTime] = useState<any>(null);
  const [popupItemAlreadyAddedInCart, setPopupItemAlreadyAddedInCart] =
    useState(false);
  const [defaultCalendardate, setDefaultCalendardate] = useState<any>(null);
  const [itemAddLimitPopUp, setItemAddLimitPopUp] = useState(false);
  const [offerActualPriceLocal, setOfferActualPriceLocal] = useState<number>(0);
  const [isSingleDatePujaEnabled, setIsSingleDatePujaEnabled] = useState(false);
  const [showSubscription, setShowSubscription] = useState<boolean>(false);
  const { cartInfo } = useSelector((state: any) => state.cart);
  const priceConversionState = useSelector(
    (state: any) => state.priceConversion,
  );
  const [subscriptionChadhavaList, setSubscriptionChadhavaList] = useState<any>(
    [],
  );
  const [chadhavaSubscriptions, setChadhavaSubscriptions] = useState<any>([]);
  const [subscriptionAddOn, setSubscriptionAddOn] = useState<any>([]);
  const [subscriptionChadhavasPrice, setSubscriptionChadhavasPrice] =
    useState<any>(null);
  const [
    selectedChadhavaSubscriptionPlan,
    setSelectedChadhavaSubscriptionPlan,
  ] = useState<any>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const { chadhavaVideos } = useSelector((state: any) => state.dashboard);
  const { chadhavaItem } = location.state || {};
  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
    platformFeeForChadhava,
  } = priceConversionState.priceConversionRate || {};
  const { isLoading } = priceConversionState;

  useEffect(() => {
    if (!selectedTempleDetails) return;
    const subscriptionAvailable = isSubscriptionAvailable(
      selectedTempleDetails?.chadhavaSubscription,
    );
    const urlWantsSubscription = searchParams.get("subscription") === "true";
    if (!subscriptionAvailable) {
      if (showSubscription) {
        handleClickSubscriptionButton(false);
      }
      if (searchParams.has("subscription")) {
        const params = new URLSearchParams(searchParams);
        params.delete("subscription");
        setSearchParams(params, { replace: true });
      }
      return;
    }
    if (urlWantsSubscription !== showSubscription) {
      handleClickSubscriptionButton(urlWantsSubscription);
    }
  }, [selectedTempleDetails?.id]);

  useEffect(() => {
    if (!selectedTempleDetails) return;
    const params = new URLSearchParams(searchParams);
    if (showSubscription) {
      params.set("subscription", "true");
    } else {
      params.delete("subscription");
    }
    setSearchParams(params, { replace: true });
  }, [showSubscription]);

  useEffect(() => {
    const templeIdLocal = location.pathname.split("/")[2];
    setTempleId(templeIdLocal);
    if (templeIdLocal) {
      // dispatch(getTempleDetailsByNameKey(templeId));
      dispatch(
        getChadhavaForTempleWithTempleDetails(
          templeIdLocal,
          isOverseas,
          platformFeeForChadhava,
          rate,
        ),
      )
        .then((response: any) => {
          if (
            !response?.templeDetails ||
            Object.keys(response?.templeDetails).length <= 0 ||
            Object.keys(response?.chadhavaItemArray).length <= 0
          ) {
            navigate("/chadhavaTemples");
            return;
          }
          if (response) {
            setSelectedTempleDetails(response?.templeDetails ?? {});

            if (response?.chadhavaItemArray?.length > 0) {
              const updatedResponse = response?.chadhavaItemArray?.map(
                (_item: any) => {
                  const isChadhavaDisabled = checkIfChadhavaDisabled(
                    _item?.restrictionChadavaDate ?? [],
                  );
                  return {
                    ..._item,
                    count: 0,
                    disabled: isChadhavaDisabled,
                  };
                },
              );
              if (
                isSubscriptionAvailable(
                  response?.templeDetails?.chadhavaSubscription,
                )
              ) {
                const filList = getFilteredChadhavaSubsList(
                  updatedResponse,
                  response?.templeDetails?.chadhavaSubscription?.chadhavaItems,
                );
                setSubscriptionChadhavaList(filList);
                setChadhavaSubscriptions(
                  response?.templeDetails?.chadhavaSubscription?.subscriptions?.filter(
                    (item: any) => item?.isSubscriptionEnabled,
                  ),
                );
                setSubscriptionAddOn(
                  getExcludedChadhavaSubsList(
                    updatedResponse,
                    response?.templeDetails?.chadhavaSubscription
                      ?.chadhavaItems,
                  ),
                );
              }
              setChadhavaList(updatedResponse);
            }
          }
        })
        .then(() => {
          if (chadhavaItem) {
            addChadhavaItem(chadhavaItem);
          }
        })
        .catch((error: any) => {
          navigate("/chadhavaTemples");
        });
    } else {
      navigate("/chadhavaTemples");
    }
  }, []);
  useEffect(() => {
    if (localRestrictionChadavaDate.length > 0) {
      checkSingleDatePuja(localRestrictionChadavaDate);
      const pujaAvailableMonth = getAvailableMonth(localRestrictionChadavaDate);
      if (pujaAvailableMonth > 0) {
        setDefaultCalendardate(dayjs().add(pujaAvailableMonth, "month"));
      }
    } else {
      setDefaultCalendardate(null);
    }
  }, [localRestrictionChadavaDate]);

  const templeProfilePic = () => {
    let imageArrayForTemple =
      selectedTempleDetails?.personalInfo &&
      selectedTempleDetails.personalInfo?.media &&
      selectedTempleDetails.personalInfo.media?.pictures &&
      selectedTempleDetails.personalInfo.media.pictures.length
        ? selectedTempleDetails?.personalInfo.media.pictures
        : [];
    let templeProfilePic = getOneImageForTemple(imageArrayForTemple);
    return templeProfilePic;
  };

  const goToBookPujaScreen = () => {
    navigate("/templePujaList/" + templeId);
  };

  const navigateToPujaStepsView = () => {
    navigate("/pujaSteps");
  };
  const navigateToSeeVideoView = () => {
    navigate("/pujaVideo");
  };

  const handleIncrement = (item: any) => {
    setChadhavaList((prev: any) =>
      prev.map((chadhava: any) => {
        if (chadhava.id === item.id) {
          const updatedCount = chadhava.count + 1;
          return { ...chadhava, count: updatedCount };
        } else {
          return chadhava;
        }
      }),
    );
  };

  const getCalculateTotalPrice = (items: any[]): number => {
    let offerPriceExist = false;
    const reducedPrice: any = items.reduce(
      ({ totalPrice, offerActualPrice }, item) => {
        const itemTotal = item.count * Number(item?.priceInfo?.finalPrice);
        totalPrice += itemTotal;
        if (item?.priceInfo?.offerActualPrice > 0) {
          if (item.count > 0) {
            offerActualPrice = truncateToTwoDecimals(
              offerActualPrice + item?.priceInfo?.offerActualPrice * item.count,
            );
            offerPriceExist = true;
          }
        } else {
          if (item.count > 0) {
            offerActualPrice = truncateToTwoDecimals(
              offerActualPrice + item?.priceInfo?.finalPrice * item.count,
            );
          }
        }
        return { totalPrice, offerActualPrice };
      },
      { totalPrice: 0, offerActualPrice: 0 },
    );
    if (reducedPrice?.offerActualPrice && offerPriceExist) {
      setOfferActualPriceLocal(reducedPrice.offerActualPrice);
    } else {
      setOfferActualPriceLocal(0);
    }
    return reducedPrice?.totalPrice ?? 0;
  };
  const getCalculateTotalPriceDisp = (items: any[]): any => {
    const chadhavaTotalValue = items.reduce((total, item) => {
      const itemTotal = Number(
        item.count * Number(item?.priceInfo?.finalPriceOv),
      ).toFixed(2);

      return Number((total + Number(itemTotal)).toFixed(2));
    }, 0);

    return chadhavaTotalValue;
  };
  useEffect(() => {
    const selectedChadhava = chadhavaList.filter(
      (item: any) => item?.count > 0,
    );
    setTotalPrice(
      truncateToTwoDecimals(getCalculateTotalPrice(selectedChadhava)),
    );
    setTotalPriceDisplay(
      truncateToTwoDecimals(getCalculateTotalPriceDisp(selectedChadhava)),
    );
  }, [chadhavaList]);

  useEffect(() => {
    if (!selectedTempleDetails?.id) return;

    const userInfo = JSON.parse(
      localStorage.getItem(LOCALSTORAGE_KEY.USERINFO) ?? "{}",
    );

    const finalPrice = showSubscription
      ? (subscriptionChadhavasPrice?.subscriptionPrice ?? 0)
      : (totalPrice ?? 0);

    const purpose =
      selectedTempleDetails?.chadhavaBenefits?.length > 0
        ? selectedTempleDetails?.chadhavaBenefits[0]?.name
        : "";

    dispatch(
      pageReady({
        User_ID: userInfo?.id ?? "Guest User",
        Chadhava_Name: selectedTempleDetails?.chadhavaTitle ?? "",
        Temple_ID: selectedTempleDetails?.id ?? "",
        Temple_Name: selectedTempleDetails?.personalInfo?.name ?? "",
        Diety: selectedTempleDetails?.personalInfo?.primaryGodName ?? "",
        Chadhava_Type: showSubscription ? "Subscription" : "OneTime",
        Page_Type: "Chadhava",
        Listing_Type: "Chadhava Detail",
        Price: truncateToTwoDecimals(finalPrice),
        Currency: currencySymbols,
        IsOverseas: isOverseas,
        rate: rate,
        IsPrasad: false,
        Purpose: purpose,
        Device_Type: getDeviceTypeFromUserAgent(),
        Platform: getDeviceTypeFromUserAgent(),
      }),
    );
  }, [
    selectedTempleDetails?.id,
    showSubscription,
    totalPrice,
    subscriptionChadhavasPrice,
  ]);

  const preprocessingAndProceedToAddmemberScreen = () => {
    // Open pupup for limiting popup and return from there
    if (
      (cartInfo && cartInfo.length === 6) ||
      (cartInfo && cartInfo.length > 6)
    ) {
      setItemAddLimitPopUp(true);
      return;
    }

    if (showSubscription && selectedChadhavaSubscriptionPlan?.subscriptionId) {
      const id = uid();
      let cartDataPayload: any = {
        id,
        cartId: id,
        membersData: [],
        templeDetails: selectedTempleDetails,
        pujaDateTime: null,
        bookedForDate: null,
        orderType: orderType.chadhava,
        price: totalPrice,
        templeId: selectedTempleDetails?.id,
        subscriptionChadhavas: subscriptionChadhavaList?.filter(
          (item: any) => item?.count > 0,
        ),
        subscriptionChadhavaAddOns: [
          ...subscriptionChadhavaList?.filter((item: any) => !item?.count),
          ...subscriptionAddOn?.filter((item: any) => !item?.count),
        ],
        currentSubscriptionPlan: selectedChadhavaSubscriptionPlan,
        isSubscribed: true,
        subscriptionId: selectedChadhavaSubscriptionPlan?.subscriptionId,
        tempPriceInfo: {
          finalPrice: truncateToTwoDecimals(
            subscriptionChadhavasPrice?.subscriptionPrice,
          ) ?? 0,
        },
      };

      dispatch(updateTempCartPayloadAction(cartDataPayload)).then(() => {
        navigate(`/checkoutV2/addDevotee`);
      });

      return;
    }

    const formattedDateToSave = getDateFormatedForMUISelection(
      pujaDateAndTime?.pujaDate?.toString(),
    );
    let dateTimeData = {
      pujaDate: formattedDateToSave,
      // pujaDate: "2025-03-08 10:30AM",
      pujaTime: "10:30AM",
    };

    const id = uid();
    let cartDataPayload: any = {
      id,
      cartId: id,
      membersData: [],
      selectedChadhvaList: filteredChadhavaList,
      localRestrictionChadavaDate: localRestrictionChadavaDate,
      templeDetails: selectedTempleDetails,
      pujaDateTime: dateTimeData,
      bookedForDate: dateTimeData,
      orderType: orderType.chadhava,
      price: totalPrice,
      templeId: selectedTempleDetails?.id,
      selectedChadhavaPackage:
        filteredChadhavaList?.filter((item: any) => item?.count > 0) ?? [],
      addOnChadhavaItems:
        filteredChadhavaList?.filter((item: any) => item?.count === 0) ?? [],
      tempPriceInfo: {
        finalPrice: totalPrice ?? 0,
      },
    };

    dispatch(updateTempCartPayloadAction(cartDataPayload)).then(() => {
      navigate(`/checkoutV2/addDevotee`);
    });
  };

  const getCommonDates = (list: any): string[] => {
    if (list.length === 0) return [];
    const firstDates = list[0]?.restrictionChadavaDate;
    return firstDates.filter((dayOrDate: any) =>
      list.every((obj: any) => obj.restrictionChadavaDate?.includes(dayOrDate)),
    );
  };

  useEffect(() => {
    const localDate: any[] = [];
    if (needToSetLocalDate) {
      const selectedChadhavaItem = [...chadhavaList].filter(
        (item: any) => item?.count > 0,
      );
      setNeedToSetLocalDate(false);
      if (selectedChadhavaItem?.length > 0) {
        let newDate: string[] = [];

        selectedChadhavaItem.forEach((el: any, idx: number) => {
          if (newDate?.length > 0) {
            const ndate: string[] = newDate.filter((item) =>
              getUpcomingDatesForDays(el?.restrictionChadavaDate).includes(
                item,
              ),
            );
            newDate = ndate;
          } else {
            newDate = getUpcomingDatesForDays(el?.restrictionChadavaDate);
          }
        });

        setLocalRestrictionChadavaDate(newDate);
        const filteredArray = chadhavaList?.filter((obj: any) => {
          const convertedRestrictionDates =
            getUpcomingDatesForDays(obj?.restrictionChadavaDate) ?? [];
          return convertedRestrictionDates
            ? convertedRestrictionDates?.some((item: any) => {
                return newDate.includes(item);
              })
            : true;
        });
        const ids = filteredArray.map((item: any) => item.id);
        const filteredArrayItem: any = [...chadhavaList].map((item: any) => {
          if (ids.includes(item.id)) {
            return { ...item, disabled: false };
          } else {
            return { ...item, disabled: true };
          }
        });
        const sortedArray = filteredArrayItem.sort(
          (a: any, b: any) => Number(a.disabled) - Number(b.disabled),
        );
        setFilteredChadhavaList(sortedArray);
        return;
      } else {
        setLocalRestrictionChadavaDate([]);
        setFilteredChadhavaList(chadhavaList);
        return;
      }
    }

    if (localRestrictionChadavaDate.length > 0) {
      const filteredArray = chadhavaList?.filter((obj: any) =>
        obj?.restrictionChadavaDate
          ? getUpcomingDatesForDays(obj?.restrictionChadavaDate)?.some(
              (item: any) => localRestrictionChadavaDate?.includes(item),
            )
          : true,
      );
      const ids = filteredArray.map((item: any) => item.id); //get id for selected chadhava item

      //Disable unmached items
      const filteredArrayItem: any = [...chadhavaList].map((item: any) => {
        if (ids.includes(item.id)) {
          return {
            ...item,
            disabled: false,
          };
        } else {
          return {
            ...item,
            disabled: true,
          };
        }
      });
      const sortedArray = filteredArrayItem.sort(
        (a: any, b: any) => Number(a.disabled) - Number(b.disabled),
      );
      setFilteredChadhavaList(sortedArray);
    } else {
      setFilteredChadhavaList(chadhavaList);
    }
  }, [chadhavaList]);

  const addChadhavaItem = (el: any) => {
    if (localRestrictionChadavaDate?.length > 0) {
      const newDates = localRestrictionChadavaDate.filter((item) =>
        getUpcomingDatesForDays(el?.restrictionChadavaDate).includes(item),
      );
      setLocalRestrictionChadavaDate(newDates);
    } else {
      setLocalRestrictionChadavaDate(
        getUpcomingDatesForDays(el?.restrictionChadavaDate),
      );
    }
    handleIncrement(el);
  };

  const [needToSetLocalDate, setNeedToSetLocalDate] = useState(false);
  const handleDecrement = (item: any) => {
    setChadhavaList((prev: any) =>
      prev.map((chadhava: any) => {
        if (chadhava.id === item.id) {
          const updatedCount = chadhava.count > 0 ? chadhava.count - 1 : 0;
          if (updatedCount === 0) {
            setNeedToSetLocalDate(true);
          }
          return { ...chadhava, count: updatedCount };
        } else {
          return chadhava;
        }
      }),
    );
  };

  const getAvilableChadhavaDate = (): string => {
    return (
      "This chadhava item is not available on the given date " +
        localRestrictionChadavaDate?.toString() || ""
    );
  };

  const shouldDisableDate = (date: any): any => {
    const restrictionDate: any = localRestrictionChadavaDate;
    if (
      typeof restrictionDate === "undefined" ||
      restrictionDate?.length === 0
    ) {
      return false;
    }

    const dayNames: string[] = restrictionDate?.filter((item: any) =>
      isNaN(Date.parse(item)),
    );

    const selectedDate = dayjs();
    const twoDaysBeforeSelected = selectedDate.add(3, "day");
    if (date.isBefore(twoDaysBeforeSelected, "day")) {
      return true;
    }

    const specificDates: Date[] = restrictionDate
      ?.filter((item: any) => !isNaN(Date.parse(item)))
      ?.map((dateString: any) => new Date(dateString));
    const disableWeekDays: number[] = dayNames
      ?.map(dayNameToNumber)
      ?.filter((day) => day !== null) as number[];
    const day: number = date.day();
    if (disableWeekDays?.includes(day)) {
      return false;
    }

    return !specificDates?.some(
      (disabledDate) =>
        date?.date() === disabledDate?.getDate() &&
        date?.month() === disabledDate?.getMonth() &&
        date?.year() === disabledDate?.getFullYear(),
    );
  };
  const hostname =
    window.location.hostname === "localhost"
      ? "http://localhost:3000"
      : "https://" + window.location.hostname;
  const chadhavaInfoPath = location.pathname;

  const imgList = getImageListFromTemple(
    selectedTempleDetails?.personalInfo,
    "chadavaPictures",
  );

  const checkSingleDatePuja = (_localRestrictionDates: any): any => {
    if (!selectedTempleDetails) {
      return false;
    }

    if (_localRestrictionDates?.length === 0) {
      return false;
    }
    const validPujaDate: string[] = _localRestrictionDates?.filter(
      (item: any) => Date.parse(item),
    );

    if (_localRestrictionDates?.length === 1 && validPujaDate?.length === 1) {
      const targetPujaDate = moment(validPujaDate[0]);
      const twoDaysAfterTodayDate = moment().add(2, "day").format("YYYY-MM-DD");
      if (targetPujaDate.isAfter(twoDaysAfterTodayDate, "day")) {
        setIsSingleDatePujaEnabled(true);
        setPujaDateAndTime({
          pujaDate: new Date(validPujaDate[0])?.toDateString(),
          pujaTime: "10:30AM",
        });
      }
    } else {
      setIsSingleDatePujaEnabled(false);
    }
  };

  if (
    !selectedTempleDetails ||
    Object.keys(selectedTempleDetails).length <= 0
  ) {
    return null;
  }

  // Subscription Button handler
  const handleClickSubscriptionButton = (isEnabled: boolean) => {
    const y = window.pageYOffset || document.documentElement.scrollTop || 0;
    setShowSubscription(isEnabled);

    setTimeout(() => {
      window?.scrollTo({ top: y, behavior: "auto" });
    }, 50);

    if (!isEnabled) return;
    if (chadhavaSubscriptions?.length === 0) return;

    // Set default plan if not selected
    let _selPlan = selectedChadhavaSubscriptionPlan;
    if (!_selPlan?.subscriptionId) {
      _selPlan = chadhavaSubscriptions[0];
      setSelectedChadhavaSubscriptionPlan(_selPlan);
    }

    // All selected items (count > 0)
    const selectedChadhava = chadhavaList?.filter(
      (item: any) => item?.count > 0,
    );
    if (!selectedChadhava?.length) return;

    // Make copies of both lists so they can be updated freely
    let updatedSubscriptionList = [...subscriptionChadhavaList];
    let updatedAddOnList = [...subscriptionAddOn];

    selectedChadhava?.forEach((selItem: any) => {
      const existsInSubscription = updatedSubscriptionList?.some(
        (itm: any) => itm?.id === selItem?.id,
      );

      const existsInAddon = updatedAddOnList?.some(
        (itm: any) => itm?.id === selItem?.id,
      );

      // CASE 1: Already in subscription → update count to 1
      if (existsInSubscription) {
        updatedSubscriptionList = updatedSubscriptionList.map((itm: any) =>
          itm?.id === selItem?.id ? { ...itm, count: 1 } : itm,
        );
      }

      // CASE 2: Exists in addon → remove from addon & add to subscription
      if (existsInAddon) {
        updatedAddOnList = updatedAddOnList.filter(
          (itm: any) => itm.id !== selItem.id,
        );
        updatedSubscriptionList.push({ ...selItem, count: 1 });
      }
    });

    // Recalculate prices
    const priceData = getTotalChadhavaSubscriptionPrices(
      updatedSubscriptionList,
      _selPlan.frequency,
      _selPlan.fixDiscount,
    );

    // Update state
    setSubscriptionChadhavaList(updatedSubscriptionList);
    setSubscriptionAddOn(updatedAddOnList);
    setSubscriptionChadhavasPrice(priceData);
  };

  const handleToggleSubscriptionChadhava = (_chadhavaId: any) => {
    if (!selectedChadhavaSubscriptionPlan?.subscriptionId) return;
    const updatedList = subscriptionChadhavaList?.map((_chadhavaItem: any) => {
      if (_chadhavaItem?.id !== _chadhavaId) {
        return _chadhavaItem;
      }
      if (_chadhavaItem?.count === 0) {
        return { ..._chadhavaItem, count: 1 };
      }
      return { ..._chadhavaItem, count: 0 };
    });
    const data = getTotalChadhavaSubscriptionPrices(
      updatedList,
      Number(selectedChadhavaSubscriptionPlan?.frequency),
      Number(selectedChadhavaSubscriptionPlan?.fixDiscount),
    );
    setSubscriptionChadhavasPrice(data);
    setSubscriptionChadhavaList(updatedList);
  };

  const handleAddFromAddOn = (_chadhava: any) => {
    if (!selectedChadhavaSubscriptionPlan?.subscriptionId) return;
    const filterFromAddons = subscriptionAddOn?.filter(
      (_itm: any) => _itm?.id !== _chadhava?.id,
    );
    setSubscriptionChadhavaList((prev: any) => [
      ...prev,
      { ..._chadhava, count: 1 },
    ]);
    const updatedSubscriptionChadhavaList = [
      ...subscriptionChadhavaList,
      { ..._chadhava, count: 1 },
    ];

    const data = getTotalChadhavaSubscriptionPrices(
      updatedSubscriptionChadhavaList,
      Number(selectedChadhavaSubscriptionPlan?.frequency),
      Number(selectedChadhavaSubscriptionPlan?.fixDiscount),
    );
    setSubscriptionChadhavasPrice(data);
    setSubscriptionAddOn(filterFromAddons);
    setSubscriptionChadhavaList(updatedSubscriptionChadhavaList);
  };

  const handleSelectSubscriptionPlan = (subscriptionPlan: any) => {
    if (!subscriptionPlan?.subscriptionId) return;
    setSelectedChadhavaSubscriptionPlan(subscriptionPlan);
    const priceData = getTotalChadhavaSubscriptionPrices(
      subscriptionChadhavaList,
      subscriptionPlan?.frequency,
      subscriptionPlan?.fixDiscount,
    );
    setSubscriptionChadhavasPrice(priceData);
  };
  return (
    <ParentView>
      <HelmetComponent
        metaData={{
          title:
            selectedTempleDetails?.chadhavaMetaData?.metaTitle ??
            selectedTempleDetails?.personalInfo?.name ??
            "Temple" + " | TempleDekho",
          keywords: selectedTempleDetails?.chadhavaMetaData?.metaKeys ?? null,
          robots: "index, follow",
          description:
            selectedTempleDetails?.chadhavaMetaData?.metaDescription ??
            selectedTempleDetails?.personalInfo?.descriptions,
          url: hostname + chadhavaInfoPath,
          imageUrl: imgList?.length ? imgList[0]?.pictureUrl : metaTempleImg,
        }}
      >
        <ChadhavaDetailsView
          templeDetails={selectedTempleDetails}
          templePersonalInfo={selectedTempleDetails?.personalInfo ?? {}}
          goToBookPujaScreen={goToBookPujaScreen}
          templeProfilePic={templeProfilePic}
          navigateToPujaStepsView={navigateToPujaStepsView}
          navigateToSeeVideoView={navigateToSeeVideoView}
          chadhavaList={chadhavaList}
          selectedChadhva={selectedChadhva}
          totalPrice={
            showSubscription
              ? truncateToTwoDecimals(
                  subscriptionChadhavasPrice?.subscriptionPrice,
                )
              : totalPrice
          }
          isDateTimePicker={isDateTimePicker}
          setIsDateTimePicker={setIsDateTimePicker}
          pujaDateAndTime={pujaDateAndTime}
          setPujaDateAndTime={setPujaDateAndTime}
          handleIncrement={handleIncrement}
          handleDecrement={handleDecrement}
          filteredChadhavaList={filteredChadhavaList}
          preprocessingAndProceedToAddmemberScreen={
            preprocessingAndProceedToAddmemberScreen
          }
          shouldDisableDate={shouldDisableDate}
          firstSelectedItemDate={firstSelectedItemDate}
          getAvilableChadhavaDate={getAvilableChadhavaDate}
          addChadhavaItem={addChadhavaItem}
          cartInfo={cartInfo}
          popupItemAlreadyAddedInCart={popupItemAlreadyAddedInCart}
          setPopupItemAlreadyAddedInCart={setPopupItemAlreadyAddedInCart}
          overSeasRate={rate}
          currencySymbols={currencySymbols}
          totalPriceDisplay={totalPriceDisplay}
          isOverseas={isOverseas}
          isCountryDisabledForBooking={
            priceConversionState?.isCountryDisabled ?? false
          }
          isLoading={isLoading}
          defaultCalendardate={defaultCalendardate}
          itemAddLimitPopUp={itemAddLimitPopUp}
          setItemAddLimitPopUp={setItemAddLimitPopUp}
          offerActualPriceLocal={
            showSubscription
              ? isOverseas
                ? truncateToTwoDecimals(
                    subscriptionChadhavasPrice?.subscriptionOfferPriceOv,
                  )
                : truncateToTwoDecimals(
                    subscriptionChadhavasPrice?.subscriptionOfferPrice,
                  )
              : offerActualPriceLocal
          }
          isSingleDatePujaEnabled={isSingleDatePujaEnabled}
          chadhavaVideos={chadhavaVideos}
          isSubscriptionAvailable={isSubscriptionAvailable(
            selectedTempleDetails?.chadhavaSubscription,
          )}
          showSubscription={showSubscription}
          handleClickSubscriptionButton={handleClickSubscriptionButton}
          subscriptionChadhavaList={subscriptionChadhavaList}
          handleToggleSubscriptionChadhava={handleToggleSubscriptionChadhava}
          chadhavaSubscriptions={chadhavaSubscriptions}
          subscriptionAddOn={subscriptionAddOn}
          handleAddFromAddOn={handleAddFromAddOn}
          selectedChadhavaSubscriptionPlan={selectedChadhavaSubscriptionPlan}
          onSelectSubscriptionPlan={handleSelectSubscriptionPlan}
          totalSubscriptionPrice={subscriptionChadhavasPrice}
          setDefaultCalendardate={setDefaultCalendardate}
          localRestrictionChadavaDate={localRestrictionChadavaDate}
        />
      </HelmetComponent>
    </ParentView>
  );
}

export default ChadhavaDetailsScreen;
